<template>
    <div>
        <div class="modal is-active">
            <div @click="close" class="modal-background"></div>
            <div class="modal-content">
                <div class="card">
                    <div class="card-content">
                        <div class="content">
                            <div class="field">
                                <label class="label">Import keywords</label>
                                <div class="file has-name">
                                    <label class="file-label">
                                        <input class="file-input" type="file" name="file" @change="setFile">
                                        <span class="file-cta">
                                            <span class="file-icon">
                                                <i class="fas fa-upload"></i>
                                            </span>
                                            <span class="file-label">
                                                Choose a file…
                                            </span>
                                        </span>
                                        <span class="file-name">
                                            {{ file?.name || 'Upload file' }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="field">
                                <p class="control">
                                    <button class="button is-success" @click="uploadFile" :disabled="uploadBtnIsDisabled">
                                        Import
                                    </button>
                                    <button class="button is-danger" style="margin-left: 10px;" @click="close">
                                        Close
                                    </button>
                                </p>
                                <p class="tag is-danger is-light" v-if="error !== null">{{ error }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button @click="close" class="modal-close is-large" aria-label="close"></button>
        </div>
    </div>
</template>

<script>

import { uploadPreference } from '../../api/api';

export default {
    data() {
        return {
            file: null,
            error: null,
            uploadBtnIsDisabled: true
        };
    },
    methods: {
        close() {
            this.$emit('close');
        },
        uploadFile() {
            this.uploadBtnIsDisabled = true;
            uploadPreference(this.file)
                .then(resp => {
                    if (resp.status !== 200) {
                        this.error = 'Something went wrong, please try again.';
                    } else {
                        this.$emit('done');
                        this.$emit('reload');
                    }
                })
                .catch(() => {
                    this.error = 'Something went wrong, please try again.';
                })
                .finally(() => {
                    this.uploadBtnIsDisabled = false;
                })
        },
        setFile(event) {
            const file = event.target.files[0];

            if (file?.type !== "text/csv") {
                this.error = 'Only csv file are accepted.';
                this.uploadBtnIsDisabled = true;
                return;
            } else if (this.error) {
                this.error = null;
            }

            this.uploadBtnIsDisabled = false;
            this.file = file;
        },
    }
}

</script>